import { ChatFileMessage } from "context/adminContext";
import { ChatFilesMessage } from "Components/ChatFiles/ChatFilesMessage";
import styles from "./index.module.css";
import { formatMessageDateTime } from "helpers/format";

type Props = {
  messageId: number;
  messageCreatedAt: string;
  isFiles: boolean;
  content: ChatFileMessage[];
};

export const SupportMessage = ({ messageId, messageCreatedAt, isFiles, content }: Props) => {
  const isZ = messageCreatedAt.at(-1) === "Z";
  const date = (
    <div className={styles.messageDate}>{formatMessageDateTime(`${messageCreatedAt}${isZ ? "" : "Z"}`)}</div>
  );

  if (isFiles) {
    // Время — отдельным пузырём, файлы под ним
    return (
      <div className={styles.filesGroup + " " + styles.myFilesGroup}>
        <div className={styles.myMessages} id={`message-${messageId}`}>
          {date}
        </div>
        <ChatFilesMessage files={content} align="right" />
      </div>
    );
  }

  return (
    <div className={styles.myMessages} id={`message-${messageId}`}>
      {date}
      <div className={styles.message}>{content[0].content}</div>
    </div>
  );
};
